import { z } from "zod";

export const schema = z.object({
    name: z
        .string()
        .min(1, "forms.general-validation.name_required")
        .regex(
            /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
            "forms.general-validation.invalid_domain_format"
        ),
    dnsDomain: z.string().optional(),
    use_for_offers: z.boolean(),
    country_id: z.number().nullable().optional(),
    default_category_ids: z.array(z.string()).optional(),
    exclude_category_ids: z.array(z.string()).optional(),
    include_category_ids: z.array(z.string()).optional(),
});

export type ManageCustomDomainFormData = z.infer<typeof schema>;
